import { getTranslation } from '@easy-expense/intl-client';
import { Icon } from '@easy-expense/ui-shared-components';
import { theme } from '@easy-expense/ui-theme';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';

type IconName = React.ComponentProps<typeof Icon>['name'];

/** Reassurance strip rendered below the plan ladder on the billing paywall. */
export const TrustStrip: React.FC = () => {
  const items: { iconName: IconName; title: string; description?: string }[] = [
    {
      iconName: 'shield-checkmark-outline',
      title: getTranslation('Secure by design'),
      description: getTranslation('Your data is encrypted and protected.'),
    },
    {
      iconName: 'refresh-outline',
      title: getTranslation('Cancel anytime'),
      description: getTranslation('No contracts or cancellation fees.'),
    },
    {
      iconName: 'pricetag-outline',
      title: getTranslation('Clear pricing'),
      description: getTranslation('No setup fees or surprise charges.'),
    },
    {
      iconName: 'happy-outline',
      title: getTranslation('Trusted by 40,000+ businesses'),
    },
  ];

  return (
    <Layout.Row
      bg="white"
      border={[1, 'solid', 'grayLight']}
      radius={16}
      px
      py={16}
      style={{ gap: 24, flexWrap: 'wrap' }}
      role="list"
    >
      {items.map((item) => (
        <Layout.Row key={item.title} align style={{ flex: 1, minWidth: 220 }} role="listitem">
          <Layout.Column bg="successXLight" radius={100} px={10} py={10} center>
            <Icon name={item.iconName} size={20} color={theme.colors.successDark} aria-hidden />
          </Layout.Column>
          <Spacer.Horizontal size={10} />
          <Layout.Column style={{ flex: 1 }}>
            <OpenSans.Primary size="s-16" weight="bold-700">
              {item.title}
            </OpenSans.Primary>
            {item.description ? (
              <OpenSans.Primary size="xs-12" color="secondary">
                {item.description}
              </OpenSans.Primary>
            ) : null}
          </Layout.Column>
        </Layout.Row>
      ))}
    </Layout.Row>
  );
};
